import React, { useRef, useState } from 'react'
import leftPointer from "../../assets/leftPointer.png";
import blackLeftPointer from "../../assets/blackLeftPointer.png";
import liteView from "../../assets/Lite view -1.mp4";
import legacyView from "../../assets/legacy view.mp4"
import useTypewriter from '../../hooks/useTypewriter';
import useOnScreen from '../../hooks/useOnScreen';
import useScrollAnimation from '../../hooks/useScrollAnimation';

const NewView = () => {

  const ref = useRef(null);
  const [activeTab, setActiveTab] = useState("lite");

  const { ref: tabsRef, isVisible: tabsVisible } = useScrollAnimation({ threshold: 0.3 });
  const isVisible = useOnScreen(ref, { threshold: 0.5 });

  const fullSubtitle = "Edit your template even \nquicker now in lite view.";

  const typedSubtitle = useTypewriter(fullSubtitle, 50, isVisible);

  const tabs = [
    { id: "lite", label: "Lite View" },
    { id: "legacy", label: "Legacy View" },
  ];

  const tabContent = {
    lite: [
      { src: liteView }
    ],
    legacy: [
      { src: legacyView }
    ],
  };

  return (
    <div className="w-full relative overflow-hidden">
      <div className="relative overflow-hidden bg-white mt-8 sm:mt-12 md:mt-16 lg:mt-20 xl:mt-22 2xl:mt-24 py-12 sm:py-16 md:py-20 lg:py-24 xl:py-28 2xl:py-32 flex md:flex-row flex-col gap-4 md:gap-0 w-full items-center justify-between px-4 sm:px-6 md:px-0">
        <div className="absolute top-[-15px] sm:top-[-20px] md:top-[-25px] lg:top-[-30px] left-0 right-0 h-[40px] sm:h-[50px] md:h-[60px] lg:h-[80px] bg-ag-green blur-xl"></div>
        <div className="flex flex-col gap-3 sm:gap-4 md:gap-5 lg:gap-6 md:ml-8 lg:ml-12 xl:ml-16 2xl:ml-20 transition-all duration-700">
          <p className="font-sourceSans font-black tracking-tighter text-center md:text-start text-ag-black text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-5xl 2xl:text-6xl flex flex-col items-center md:items-start">
            <span className='flex flex-row items-center gap-2 text-xl md:text-2xl lg:text-3xl font-medium tracking-normal text-ag-black mb-1 sm:mb-2'>
              <img src={leftPointer} alt="pointer" width={16} height={16} className="object-contain" /> Lite mode
            </span>
            <span className="block font-sourceSans font-light italic mt-1 sm:mt-2">Edit <span className='font-bold not-italic'>Instantly,</span></span>
          </p>
          <p
            ref={ref}
            className="font-medium text-center md:text-start text-base sm:text-lg md:text-xl lg:text-2xl xl:text-2xl 2xl:text-3xl text-ag-black-300"
          >
            {typedSubtitle.split('\n').map((line, index, arr) => (
              <span key={index} className="block">
                {line}
                {index === arr.length - 1 && isVisible && typedSubtitle.length < fullSubtitle.length && (
                  <span className="animate-pulse text-ag-green">|</span>
                )}
              </span>
            ))}
          </p>
        </div>
        <div className="w-full md:w-auto flex-1 transition-all duration-700 relative flex justify-center lg:justify-end xl:mr-12" style={{ transitionDelay: '200ms' }}>
          <div className="w-full max-w-4xl relative flex flex-col items-center">
            <div
              ref={tabsRef}
              className={`flex justify-center mb-4 sm:mb-5 md:mb-6 lg:mb-7 xl:mb-8 px-2 sm:px-3 md:px-4 transition-all duration-700 ${tabsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
                }`}
            >
              <div className="bg-ag-black-700 max-w-5xl flex flex-wrap sm:flex-nowrap justify-center sm:justify-between gap-2 sm:gap-3 md:gap-4 px-2 sm:px-3 md:px-4 py-2 sm:py-3 md:py-4 overflow-x-auto border border-ag-black-600 rounded-xl sm:rounded-2xl md:rounded-3xl w-full">
                {tabs.map((tab, index) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`whitespace-nowrap text-xs sm:text-sm md:text-base lg:text-lg font-semibold px-3 sm:px-4 md:px-6 lg:px-8 py-1.5 sm:py-2 rounded-lg sm:rounded-xl transition-all duration-300 focus:outline-none focus:ring-0 focus:ring-offset-0 hover:scale-105 btn-press ${activeTab === tab.id
                      ? "bg-primary-50 text-black hover:bg-ag-green border-2 sm:border-3 md:border-4 border-ag-green shadow-lg shadow-ag-green/20"
                      : "bg-ag-black-700 hover:bg-ag-black-600 font-sourceSans font-bold text-ag-black-300 border sm:border-2 border-black hover:border-ag-green/50"
                      }`}
                    style={{ transitionDelay: `${index * 50}ms` }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="w-full">
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  className={`w-full ${activeTab === tab.id ? 'block' : 'hidden'}`}
                >
                  {tabContent[tab.id].map((card, index) => (
                    <div
                      key={`${tab.id}-${index}`}
                    >
                      <video
                        src={card.src}
                        alt={`${tab.label}`}
                        autoPlay
                        loop
                        playsInline
                        className="hover:shadow-xl hover:shadow-ag-green/10 transition-shadow duration-300 rounded-xl"
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Marquee text section */}
      <div className="w-full bg-ag-green overflow-hidden">
        <div className="mx-auto w-full max-w-8xl px-3 sm:px-4 py-4 sm:py-5 md:py-6 lg:py-7 xl:py-8">
          <div className="overflow-hidden whitespace-nowrap">
            <p className="inline-block text-center font-sourceSans animate-marquee hover:animate-none cursor-default">
              {[...Array(8)].map((_, i) => (
                <span key={i} className="inline-flex items-center px-4 md:px-6 align-middle">
                  <span className="text-black font-black text-xl md:text-2xl tracking-tighter">NEW VIEW <span className="font-light italic tracking-normal opacity-90 ml-1">on Autograph</span></span>
                  <img src={blackLeftPointer} alt="arrow" className="w-[18px] md:w-[22px] object-contain ml-8 md:ml-12" />
                  <span className="font-semibold text-black text-lg md:text-xl ml-3 tracking-wide">Lite mode</span>
                  <span className="px-6 opacity-0">·</span>
                </span>
              ))}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
};

export default NewView;